export function getLectors(state) {
  return state.lectors;
}

export function getLectorById(state) {
  return id => {
    return (
      state.lectors.find(lector => {
        return id === lector?.id;
      }) ?? null
    );
  };
}
